import AppWrapper from "../../components/cm/AppWrapper";
import LogSMS from "../../components/cm/Dashboard/FullPages/LogSMS";
import SideBarMain from "../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <LogSMS />
    </AppWrapper.WithSidebar>
  );
};
